import { retrievePricing } from './Plan';

// Create the exportable object
const ApiService = {
	retrievePricing,
};

// Export the object as the default export
export default ApiService;
